import mixpanel from "mixpanel-browser";
import { context } from "../../components/wr-context";
var previousValue = null;
var onHistoryChange = function(history) {
    var currentValue = history.pathname;
    if (previousValue !== currentValue) {
        if (currentValue.includes("/product/")) {
            var serviceId = currentValue.substring(9).replace("/", "");
            mixpanel.track(context.constants.analytics.serviceDetailsViewed, {
                serviceId: serviceId
            });
        } else {
            mixpanel.track("Viewed page ".concat(currentValue));
        }
    }
    previousValue = currentValue;
};
export var startAnalyticsPageListener = function() {
    context.history.listen(onHistoryChange);
};
